
















import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component
export default class FloatingContact extends Vue {
    @Prop() theme?: "white" | "black";

    params: any = { per_page: 99, page: 1, type: "kantoor" };

    open = false;

    loading = false;

    offices: any = [];

    mounted() {
        this.getOffices();
    }

    private getOffices() {
        this.loading = true;

        // @ts-ignore
        axios
            .get("/api/offices", { params: { ...this.params } })
            .then((response: any) => {
                //console.log(response.data.data);

                this.offices = Object.values(response.data.data).sort((a: any, b: any) => {
                    return a.title.rendered.localeCompare(b.title.rendered);
                });
            })
            .finally(() => (this.loading = false));
    }
}
